// src/EmailVerificationScreen.js ver 01 11/11/2025  4:37:46 PM - SB102

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './App';

function EmailVerificationScreen() {
    const auth = useAuth();
    const navigate = useNavigate();
    const [statusMessage, setStatusMessage] = useState('');
    const [resendLoading, setResendLoading] = useState(false);
    const [resendError, setResendError] = useState(null);

    const user = auth.user;

    useEffect(() => {
        if (!user) {
            // If somehow reached here without a user, redirect to login
            navigate('/login');
            return;
        }
        if (user.emailVerified) {
            // If user somehow lands here and is already verified, redirect to app
            navigate('/inventory');
        }
        setStatusMessage(`A verification email has been sent to ${user.email}. Please check your inbox (and spam folder) to verify your account.`);
    }, [user, navigate]);


    const handleResendVerification = async () => {
        if (!user) {
            setResendError("No user logged in to resend verification email.");
            return;
        }
        setResendLoading(true);
        setResendError(null);
        try {
            // Firebase Authentication allows resending verification email without needing a token
            await auth.verifyEmail(user); // Use the verifyEmail function from AuthContext
            setStatusMessage("Another verification email has been sent. Please check your inbox!");
        } catch (err) {
            console.error("Error resending verification email:", err);
            setResendError(`Failed to resend verification email: ${err.message}`);
        } finally {
            setResendLoading(false);
        }
    };

    const handleLogout = async () => {
        await auth.logout();
        navigate('/login');
    };

    if (!user || user.emailVerified) {
        // This component should only render if there's an unverified user
        return null;
    }

    return (
        <div className="verification-container">
            <div className="verification-card">
                <h2>Email Verification Required</h2>
                <p>{statusMessage}</p>
                {resendError && <p style={{ color: 'red', marginBottom: '1rem' }}>{resendError}</p>}
                
                {/* Ver 01 SB102 - this is replaced by new script below
                <button onClick={handleResendVerification} disabled={resendLoading} className="secondary">
                    {resendLoading ? 'Sending...' : 'Resend Verification Email'}
                </button> */}

                {/* NEW Ver 01 SB102: Changed button to an anchor tag (link) */}
                <p style={{ marginTop: '1rem' }}>
                    Didn't receive the email? <a href="#" onClick={handleResendVerification} disabled={resendLoading}>
                        {resendLoading ? 'Sending...' : 'Resend Verification Email'}
                    </a>
                </p>

                
                <p style={{ marginTop: '1.5rem', fontSize: '0.9em' }}>
                    After verifying your email, please <a href="#" onClick={handleLogout}>Log Out</a> and then log back in to access the application.
                </p>
                <button onClick={handleLogout} className="danger">Logout</button>
            </div>
        </div>
    );
}

export default EmailVerificationScreen;